/**
 * 应用根组件：主题、中文化、全局消息上下文、路由。
 */

import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { FeedbackBridge } from '@/components/FeedbackBridge';
import { AppRoutes } from '@/router';
import { useAuthStore } from '@/stores/auth';

dayjs.locale('zh-cn');

export default function App(): React.ReactElement {
  const bootstrap = useAuthStore((s) => s.bootstrap);

  useEffect(() => {
    // 刷新页面后用本地令牌换取最新权限上下文，保证菜单与后端权限一致
    void bootstrap();
  }, [bootstrap]);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
        },
        components: {
          Table: {
            // 财务列表信息密度：紧凑但不拥挤
            cellPaddingBlockSM: 6,
            headerBg: '#fafafa',
          },
          Layout: {
            headerHeight: 56,
            headerPadding: '0 16px',
          },
        },
      }}
    >
      <AntdApp>
        <FeedbackBridge />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}
